import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { ManageService } from '../../../../../services/manage.service';
import { CommonService } from '../../../../../services';
import { takeUntil } from 'rxjs/operators';
import { combineLatest, Subject } from 'rxjs';
@Component({
  selector: 'app-budget-and-alerts-details',
  templateUrl: './budget-and-alerts-details.component.html',
  styleUrls: ['./budget-and-alerts-details.component.css']
})
export class BudgetAndAlertsDetailsComponent implements OnInit {

  public tenantId: string;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public budgetDetailDataSrc: any[] = [];
  public displayedColumns: string[] = [
    'type',
    'percent',
    'amount',
  ];

  public budget: any;

  constructor(
    private manageService: ManageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public commonService: CommonService
  ) {}

  async ngAfterViewInit(): Promise<void> {
    await this.commonService.waitForElm('#levelOne');
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 + $('#azureSubscription').width()}, 400);
  }

  ngOnInit() {
    combineLatest([
      this.activatedRoute.parent.parent.params,
      this.activatedRoute.params
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([tenantParams, subParams]) => {
        this.tenantId = tenantParams['tenantId'];
        
        this.fetchBugetAndAlertsDetail(subParams['budgetName'])
      });


  }

  private fetchBugetAndAlertsDetail(budgetName: string): void {
    this.manageService
      .GetBudgetAlertByName(this.tenantId, budgetName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: any) => {
        this.budget = result

        // we have 2 fixed type alerts
        if (this.budget.properties.notifications.criticalAlert) {
          this.budgetDetailDataSrc.push({
            type: 'Critical',
            percent: this.budget.properties.notifications.criticalAlert.threshold,
            amount: this.budget.properties.amount * (this.budget.properties.notifications.criticalAlert.threshold/100)
          })
        }
        if (this.budget.properties.notifications.warningAlert) {
          this.budgetDetailDataSrc.push({
            type: 'Warning',
            percent: this.budget.properties.notifications.warningAlert.threshold,
            amount: this.budget.properties.amount * (this.budget.properties.notifications.warningAlert.threshold/100)
          })
        }
      },  (error: any) => {
        this.commonService.implementToast(error, 'Error');
      })
  }

  public editBudget(): void {
    this.manageService.monitorCurrentBudget(this.budget)
    this.router.navigate([`../../BudgetAlertEdit/${this.budget.name}`], { relativeTo: this.activatedRoute });
  }

  public deleteBudget(): void {
    
  }

  close() {
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
    this.router.navigate(['../../'], { relativeTo: this.activatedRoute })
  }

}
